import * as React from 'react';

const SvgFlash = (props) => (
  <svg
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M35.802 5.2c.357.864.505 1.897.505 3.013v15.05h5.46c1.853 0 3.851.567 4.657 2.351.806 1.785-.093 3.656-1.316 5.038l-.001.002-17.66 20.062c-.737.837-1.531 1.515-2.369 1.928-.845.417-1.87.622-2.888.24-1.018-.382-1.655-1.213-2.015-2.085-.357-.863-.505-1.896-.505-3.012v-15.05h-5.46c-1.84 0-3.832-.56-4.639-2.34-.805-1.776.08-3.646 1.287-5.037l.008-.01L28.53 5.284c.737-.837 1.531-1.515 2.368-1.928.845-.417 1.87-.622 2.888-.24 1.019.382 1.656 1.213 2.016 2.085Z' />
  </svg>
);

export default SvgFlash;
